import React, { useMemo } from 'react';

import { useProjects } from '../../../contexts/settings';
import { ProjectName } from './style';

type Props = {
  clientId: string;
};

const CustomBabkaName = ({ clientId }: Props): JSX.Element => {
  const { babkaLoginClient } = useProjects();

  const client = useMemo(
    () => babkaLoginClient?.find((x) => x.id === Number(clientId)),
    [babkaLoginClient]
  );

  return (
    <>
      <ProjectName data-test-id="project-name">{client?.name}</ProjectName>
    </>
  );
};

export default CustomBabkaName;
